<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  mounted () {
    this.onResizeWindow()

    if (localStorage.getItem(this.$token)) {
      this.getUserInfo()
      $.ajaxSetup({
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem(this.$token)
        }
      })
    }

    $(document.body).tooltip({ selector: '[title]' })

    if (localStorage.hasOwnProperty('locale')) {
      this.$axios.defaults.headers.common['X-localization'] = localStorage.getItem('locale')
    } else {
      this.$axios.defaults.headers.common['X-localization'] = 'en'
    }
  }
}
</script>

<style>
.wrapper {
  height: 100vh !important;
}
</style>
